module.exports = __webpack_public_path__ + "static/media/round11.916f8cfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/round11.png
// module id = 1162
// module chunks = 0